/* eslint-disable react/prop-types */

import React from 'react';

function HashtagBadge({ usageCount }) {
  if (usageCount >= 4000) return <span className="badge bg-danger rounded-pill">High</span>;
  if (usageCount >= 2500) return <span className="badge bg-warning text-dark rounded-pill">Medium High</span>;
  if (usageCount >= 1250) return <span className="badge bg-info rounded-pill">Medium</span>;
  if (usageCount >= 700) return <span className="badge bg-success rounded-pill">Low</span>;
  return <span className="badge bg-secondary rounded-pill">Very Low</span>;
}

export default HashtagBadge;
